import React, { useMemo, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import SearchIcon from "@material-ui/icons/Search";
import InputAdornment from "@material-ui/core/InputAdornment";
import Tooltip from "@material-ui/core/Tooltip";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ProcessingDialog from "../ProcessingDialog/ProcessingDialog";
import {
  setSelectedFile,
  setUploadResponse,
} from "../../../../store/file/actions";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  uploadTemplateByDocumentId,
} from "../../../../services/FileUploadService";
import { styled } from "@mui/material/styles";
import { colors } from "../../../../components/theme";

import Dialog from "@mui/material/Dialog";
import NbTreeFile from "../../../DocplaceSign_Module/tree/treeFile";

// View mode toggle imports
import ViewModuleIcon from "@material-ui/icons/ViewModule";
import ViewListIcon from "@material-ui/icons/ViewList";
import { Title } from "../../../../components/title/style";
import { Backspace } from "@material-ui/icons";
import SortIcon from "@material-ui/icons/Sort";

import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import AssignmentOutlinedIcon from "@material-ui/icons/AssignmentOutlined";
import HourglassEmptyOutlinedIcon from "@material-ui/icons/HourglassEmptyOutlined";
import DoneAllOutlinedIcon from "@material-ui/icons/DoneAllOutlined";
import ArchiveOutlinedIcon from "@material-ui/icons/ArchiveOutlined";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },

  "& .MuiDialog-paper": {
    width: "762px",
    maxWidth: "762px",
  },
}));
const useStyles = makeStyles((theme) => ({
  appBar: {
    // Ajustes adicionales si lo deseas
  },
  toolbar: { display: "flex", flexDirection: "column", gap: 10, padding: 0 },
  rowPrimary: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    flexWrap: "wrap",
  },
  rowSecondary: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    flexWrap: "wrap",
  },
  rowUtility: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    flexWrap: "wrap",
  },
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent", // so only the inner span shows
    "& > span": {
      maxWidth: 95, // <-- length of the line (adjust)
      width: "100%",
      height: 3, // thickness
      borderRadius: 2,
      backgroundColor: " #0076FF",
    },
  },
  leftSection: { display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" },
  tabsContainer: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#fff",
    borderRadius: "8px",
    overflowX: "auto",
  },
  tabs: {
    marginRight: theme.spacing(1),
    color: colors.blue,
  },
  tabLabel: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6, // space between text and dot
    position: "relative",
  },
  redDot: {
    display: "inline-block",
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "#E53935", // red
    boxShadow: "0 0 0 2px #fff", // white ring to separate from text
  },
  buttonSearch: {
    color: "rgb(251, 167, 48)",
    cursor: "pointer",
    flexShrink: 0,
  },

  // Optional: pulsing animation (use .redDotPulse instead of .redDot)
  "@keyframes pulse": {
    "0%": { transform: "scale(1)", opacity: 1 },
    "70%": { transform: "scale(1.6)", opacity: 0 },
    "100%": { transform: "scale(1)", opacity: 0 },
  },
  redDotPulse: {
    position: "relative",
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "#E53935",
    "&::after": {
      content: '""',
      position: "absolute",
      inset: -2,
      borderRadius: "50%",
      border: "2px solid #E53935",
      animation: "$pulse 1.6s ease-out infinite",
    },
  },

  tab: {
    fontSize: "14px",
    textTransform: "none",
    fontWeight: 500,
    minWidth: "100px !important",
    minHeight: 36,
    paddingInline: 10,
    opacity: 1,
    color: "#6B7280",
    "&.Mui-selected": {
      color: colors.blue,
      fontWeight: 600,
    },
  },
  rightSection: { display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" },
  searchInput: {
    backgroundColor: "#fff",
    width: "340px",
    textTransform: "none",
    borderRadius: "8px",
  },
  newTemplateButton: {
    textTransform: "none",
  },
  primaryCta: {
    textTransform: "none",
    fontWeight: 700,
    boxShadow: "none",
    whiteSpace: "nowrap",
  },
  splitCtaButton: {
    textTransform: "none",
    boxShadow: "none",
    whiteSpace: "nowrap",
  },
  headerActions: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    flexWrap: "wrap",
  },
  // View mode toggle styles (Explorer-style)
  viewModeContainer: {
    display: "flex",
    alignItems: "center",
  },
  viewModeText: {
    fontSize: "12px",
    fontWeight: "normal",
    color: "#666",
    marginRight: theme.spacing(1),
  },
  viewModeButton: {
    width: "36px",
    height: "36px",
    padding: "18px",
    cursor: "pointer",
    border: "1px solid #ddd",
    color: colors.blue,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "transparent",
    "&:first-child": {
      borderTopLeftRadius: "4px",
      borderBottomLeftRadius: "4px",
      borderRight: "none",
    },
    "&:last-child": {
      borderTopRightRadius: "4px",
      borderBottomRightRadius: "4px",
    },
  },
  viewModeActive: {
    backgroundColor: colors.blue,
    color: "#fff",
    "& .MuiSvgIcon-root": {
      color: "#fff",
    },
  },
  viewModeInactive: {
    backgroundColor: "#fff",
    color: colors.blue,
    "& .MuiSvgIcon-root": {
      color: colors.blue,
    },
  },
}));

export default function TemplateHeader({
  tabValue,
  onTabChange,
  viewMode,
  onViewModeChange,
  assignedCount = 0,
  sentCount = 0,
  myTemplatesCount = 0,
  completedCount = 0,
  archiveCount = 0,
  valueSearch = "",
  onSearchChange,
  onSearch,
  sortBy,
  sortOrder,
  onSortChange,
}) {
  const classes = useStyles();
  const [showProcessing, setShowProcessing] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showRequest, setShowRequest] = useState(false);
  const [sortMenuAnchorEl, setSortMenuAnchorEl] = useState(null);
  const [useAi, setUseAi] = useState(true);

  const handleChangeTab = (event, newValue) => {
    onTabChange(newValue);
  };

  const handleOpenStartFromTemplate = () => setShowRequest(true);

  const handleClearSearch = () => {
    if (onSearchChange) onSearchChange("");
    if (onSearch) onSearch("");
  };
  const renderTabLabel = (text, showDot, classes, pulsing = false) => (
    <span className={classes.tabLabel}>
      {text}
      {showDot && (
        <span className={pulsing ? classes.redDotPulse : classes.redDot} />
      )}
    </span>
  );
  const handleUploadByDocumentId = async (documentId, templateName) => {
    setShowProcessing(true);

    try {
      const response = await uploadTemplateByDocumentId(documentId, { useAi, templateName });
      if (response?.data?.data) {
        dispatch(setSelectedFile(documentId));
        dispatch(setUploadResponse(response.data.data));
      }
      console.log("response", response);
      navigateToTemplateBuilder(response.data.data.FormTemplateId);
    } catch (err) {
      console.error(err);
    } finally {
      setShowProcessing(false);
    }
  };

  const setRequest = (item, templateName) => {
    setShowRequest(false);
    const id = item?.[0]?.id;
    if (id) handleUploadByDocumentId(id, templateName);
  };

  const navigateToTemplateBuilder = (documentId) => {
    navigate(`/templates-v2/template-builder/${documentId}?mode=edit`);
  };

  const sortOptions = useMemo(
    () => [
      {
        id: "recent",
        label: "Sort by: Date ↓",
        sortBy: "createdAt",
        sortOrder: "desc",
      },
      { id: "name_asc", label: "Sort by: Name (A–Z)", sortBy: "templateName", sortOrder: "asc" },
      { id: "name_desc", label: "Sort by: Name (Z–A)", sortBy: "templateName", sortOrder: "desc" },
      { id: "date_asc", label: "Sort by: Date ↑", sortBy: "createdAt", sortOrder: "asc" },
    ],
    []
  );
  const activeSortLabel = useMemo(() => {
    const match = sortOptions.find(
      (o) => o.sortBy === sortBy && o.sortOrder === sortOrder
    );
    return match?.label || "Sort by";
  }, [sortBy, sortOrder, sortOptions]);

  return (
    <div>
      <Title>DocPlace Forms</Title>
      <header className={classes.appBar}>
        <div className={classes.toolbar}>
          {/* Row 1 (primary): Title + CTA */}
          <div className={classes.rowPrimary}>
            <div />
            <div />
          </div>

          {/* Row 2 (secondary): Tabs */}
          <div className={classes.rowSecondary}>
            <div className={classes.tabsContainer}>
              <Tabs
                value={tabValue}
                onChange={handleChangeTab}
                className={classes.tabs}
                textColor="primary"
                indicatorColor="primary"
                classes={{ indicator: classes.indicator }}
                TabIndicatorProps={{ children: <span /> }} // needed so we can style the child
              >
                <Tab
                  icon={<DescriptionOutlinedIcon fontSize="small" />}
                  label={`My Templates (${myTemplatesCount || 0})`}
                  className={classes.tab}
                />
                <Tab
                  icon={<AssignmentOutlinedIcon fontSize="small" />}
                  label={renderTabLabel(
                    `Assigned (${assignedCount || 0})`,
                    assignedCount > 0,
                    classes /*, true to pulse */
                  )}
                  className={classes.tab}
                />
                <Tab
                  icon={<HourglassEmptyOutlinedIcon fontSize="small" />}
                  label={renderTabLabel(
                    `Sent (${sentCount || 0})`,
                    sentCount > 0,
                    classes /*, true to pulse */
                  )}
                  className={classes.tab}
                />
                <Tab
                  icon={<DoneAllOutlinedIcon fontSize="small" />}
                  label={`Completed (${completedCount || 0})`}
                  className={classes.tab}
                />
                <Tab
                  icon={<ArchiveOutlinedIcon fontSize="small" />}
                  label={`Archive (${archiveCount || 0})`}
                  className={classes.tab}
                  disabled={archiveCount === 0}
                />
              </Tabs>
            </div>
            <Tooltip
              title={
                archiveCount === 0 ? "No archived templates yet" : "Create a new template"
              }
              arrow
            >
              <span>
                <Button
                  variant="contained"
                  color="primary"
                  style={{ backgroundColor: colors.blue }}
                  className={`${classes.newTemplateButton} ${classes.primaryCta}`}
                  onClick={handleOpenStartFromTemplate}
                >
                  New Template
                </Button>
              </span>
            </Tooltip>
          </div>

          {/* Row 3 (utility): Search + Sort + View */}
          <div className={classes.rowUtility}>
            {(tabValue === 0 || tabValue === 3) ? (
              <div className={classes.headerActions}>
                <TextField
                  variant="outlined"
                  size="small"
                  placeholder="Search templates..."
                  className={classes.searchInput}
                  value={valueSearch}
                  onChange={(e) => onSearchChange?.(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon color="primary" />
                      </InputAdornment>
                    ),
                    endAdornment:
                      valueSearch && valueSearch.length > 0 ? (
                        <Backspace
                          onClick={handleClearSearch}
                          className={classes.buttonSearch}
                          alt="Delete"
                        />
                      ) : null,
                    style: {
                      height: "36px",
                    },
                  }}
                />

                <Button
                  variant="outlined"
                  className={classes.splitCtaButton}
                  startIcon={<SortIcon />}
                  onClick={(e) => setSortMenuAnchorEl(e.currentTarget)}
                  style={{ height: 36 }}
                >
                  {activeSortLabel}
                </Button>
                <Menu
                  anchorEl={sortMenuAnchorEl}
                  open={Boolean(sortMenuAnchorEl)}
                  onClose={() => setSortMenuAnchorEl(null)}
                  anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                  transformOrigin={{ vertical: "top", horizontal: "left" }}
                >
                  {sortOptions.map((opt) => (
                    <MenuItem
                      key={opt.id}
                      selected={opt.sortBy === sortBy && opt.sortOrder === sortOrder}
                      onClick={() => {
                        setSortMenuAnchorEl(null);
                        onSortChange?.(opt.sortBy, opt.sortOrder);
                      }}
                    >
                      {opt.label}
                    </MenuItem>
                  ))}
                </Menu>
              </div>
            ) : (
              <div />
            )}

            {(tabValue === 0 || tabValue === 3 || tabValue === 4) &&
              onViewModeChange && (
                <div className={classes.viewModeContainer}>
                  <div style={{ display: "flex" }}>
                    <Tooltip title="Grid view" arrow>
                      <button
                        type="button"
                        aria-label="Grid view"
                        className={`${classes.viewModeButton} ${
                          viewMode === "grid"
                            ? classes.viewModeActive
                            : classes.viewModeInactive
                        }`}
                        onClick={() => onViewModeChange("grid")}
                      >
                        <ViewModuleIcon style={{ fontSize: "22px" }} />
                      </button>
                    </Tooltip>
                    <Tooltip title="List view" arrow>
                      <button
                        type="button"
                        aria-label="List view"
                        className={`${classes.viewModeButton} ${
                          viewMode === "list"
                            ? classes.viewModeActive
                            : classes.viewModeInactive
                        }`}
                        onClick={() => onViewModeChange("list")}
                      >
                        <ViewListIcon style={{ fontSize: "22px" }} />
                      </button>
                    </Tooltip>
                  </div>
                </div>
              )}
          </div>
        </div>
      </header>
      <ProcessingDialog open={showProcessing} />
      <BootstrapDialog
        onClose={() => {
          setShowRequest(false);
        }}
        aria-labelledby="customized-dialog-title"
        open={showRequest}
      >
        <NbTreeFile
          onClickClose={() => setShowRequest(false)}
          onClickRequest={setRequest}
          useAiEnabled={useAi}
          onUseAiEnabledChange={setUseAi}
        />
      </BootstrapDialog>
    </div>
  );
}
